import fetch from "node-fetch";
import { ApolloClient, InMemoryCache, createHttpLink } from "@apollo/client";
const defaultOptions = {
  watchQuery: {
    fetchPolicy: "no-cache",
    errorPolicy: "ignore",
  },
  query: {
    fetchPolicy: "no-cache",
    errorPolicy: "all",
  },
};

const client = new ApolloClient({
  link: createHttpLink({
    uri: process.env.NEXT_PUBLIC_PROD_GRAPHQL_URI,
    fetch: fetch,
  }),
  cache: new InMemoryCache({
    dataIdFromObject: (object) => object.key || null,
  }),
  defaultOptions,
});

export default client;
